import React from "react";
import "../Page.css";
import cors from "../../Assets/security/cors.png"
import document from "../../Assets/security/document.png"
import security from "../../Assets/security/security.png"
import security_alert from "../../Assets/security/shield-alert.png"
import clip from "../../Assets/security/clipboard.png"
import browser from "../../Assets/security/browse.png"
import lock from "../../Assets/security/lock.png"
import group from "../../Assets/security/group.png"
import userlock from "../../Assets/security/user-lock.png"
import keys from "../../Assets/security/keys.png"
import fileShield from "../../Assets/security/file-security.png"
import setting from "../../Assets/security/settings.png"
import SecurityCard1 from "./securityCards/SecurityCards";
import req_pro_icon from "../../Assets/security/request-protection.svg"
import tls_icon from "../../Assets/security/tls.svg"
import auth_icon from "../../Assets/security/access-control.svg"
import header_policy_icon from "../../Assets/security/policy-security.svg"

const ServerSecurity = () => {

    const codeSnippet = `const greet = () => {
    console.log("Hello, World!");
  };`;

    const requestAndInputProtection = [
        {
            title: "CORS Restrictions",
            description: "Restrict cross-origin requests to trusted domains.",
            logo: cors,
            status: 1
        },
        {
            title: "Payload Size",
            description: "Limit incoming request body size to prevent abuse.",
            logo: document,
            status: 1
        },
        {
            title: "Rate Limiting",
            description: "Limit request rate per IP to prevent denial-of-service attacks.",
            logo: security_alert,
            status: 1
        },
        {
            title: "XSS Protection",
            description: "Sanitize inputs and escape outputs to prevent script injections.",
            logo: document,
            status: 1
        },
        {
            title: "CSRF Tokens",
            description: "Use tokens to ensure legitimate requests come from trusted sessions.",
            logo: security,
            status: 1
        },
        {
            title: "Sanitization",
            description: "Validate all inputs against a strict schema and sanitize before use.",
            logo: clip,
            status: 1
        }
    ];


    const transportLayerSecurity = [
        {
            title: "HTTPS / SSL",
            description: "Encrypt all data in transit with HTTPS/SSL.",
            logo: lock,
            status: 1
        },
        {
            title: "HSTS Headers",
            description: "Force browsers to only use HTTPS by default.",
            logo: browser,
            status: 1
        }
    ];

    const authenticationAndAccessControl = [
        {
            title: "JWT / OAuth / Session-Based Auth",
            description: "Secure authentication using tokens or sessions.",
            logo: group,
            status: 1
        },
        {
            title: "Role-Based Access Control (RBAC)",
            description: "Restrict actions based on user roles.",
            logo: userlock,
            status: 1
        },
        {
            title: "Password Hashing & Management",
            description: "Store passwords securely using bcrypt or Argon2.",
            logo: keys,
            status: 1
        }
    ];

    const headerAndPolicySecurity = [
        {
            title: "Helmet Security Headers",
            description: "Use Helmet to set secure HTTP headers.",
            logo: security,
            status: 1
        },
        {
            title: "Content Security Policy (CSP)",
            description: "Prevent XSS by restricting sources for scripts and styles.",
            logo: fileShield,
            status: 1
        },
        {
            title: "Referrer-Policy, XCTO",
            description: "Prevent data leakage and enforce strict content handling.",
            logo: setting,
            status: 1
        }
    ];

    return (
        <div className="DashboardPage" style={{ alignItems: "start", justifyContent: "start", flexDirection: "column", gap: "20px" }}>
            <div className="component-card">
                <div className="header_integration">
                    <div className="name_header_int">

                        <div className="int_heading_content">
                            <h4>Request & Input Protection</h4>
                        </div>

                    </div>
                    <img className="int_logo" src={req_pro_icon} />

                </div>
                <div className="security_features">
                    {requestAndInputProtection.map((item, index) => (
                        <SecurityCard1
                            key={index}
                            logo={item.logo}
                            heading={item.title}
                            description={item.description}
                            status={item.status}
                        />
                    ))}
                </div>
            </div>

            <div className="component-card">

                <div className="header_integration">
                    <div className="name_header_int">

                        <div className="int_heading_content">
                            <h4>Transport Layer Security</h4>
                        </div>

                    </div>
                    <img className="int_logo" src={tls_icon} />

                </div>
                <div className="security_features">
                    {transportLayerSecurity.map((item, index) => (
                        <SecurityCard1
                            key={index}
                            logo={item.logo}
                            heading={item.title}
                            description={item.description}
                            status={item.status}
                        />
                    ))}
                </div>
            </div>

            <div className="component-card">

                <div className="header_integration">
                    <div className="name_header_int">

                        <div className="int_heading_content">
                            <h4>Authentication & Access Control</h4>
                        </div>

                    </div>
                    <img className="int_logo" src={auth_icon} />

                </div>
                <div className="security_features">
                    {authenticationAndAccessControl.map((item, index) => (
                        <SecurityCard1
                            key={index}
                            logo={item.logo}
                            heading={item.title}
                            description={item.description}
                            status={item.status}
                        />
                    ))}
                </div>
            </div>

            <div className="component-card">

                <div className="header_integration">
                    <div className="name_header_int">

                        <div className="int_heading_content">
                            <h4>Header & Policy Security</h4>
                        </div>

                    </div>
                    <img className="int_logo" src={header_policy_icon} />

                </div>
                <div className="security_features">
                    {headerAndPolicySecurity.map((item, index) => (
                        <SecurityCard1
                            key={index}
                            logo={item.logo}
                            heading={item.title}
                            description={item.description}
                            status={item.status}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ServerSecurity;